/**
 * Shared array-param serialiser. Axios's default emits `ids=a&ids=b` (no
 * brackets), which PHP's `array` validation rule does not parse as an array.
 */
export const serializeBracketedArrayParams = (params: Record<string, unknown>): string => {
    const usp = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
        if (Array.isArray(value)) {
            value.forEach((v) => usp.append(`${key}[]`, String(v)));
        } else if (value !== undefined && value !== null) {
            usp.append(key, String(value));
        }
    });
    return usp.toString();
};
